import type { AbilityBuilder, MongoQuery } from '@casl/ability'
import type { AppAbility } from '~/types/authorization.type'
import type { Task } from '~/types/task.type'
import type { User } from '~/types/user.type'
import { userRoles } from '../roles'

export function defineTaskAbilities(abilityBuilder: AbilityBuilder<AppAbility>, user: User) {
  const { can, cannot } = abilityBuilder

  can('read', 'tasks-id')
  type TaskQuery = MongoQuery<Task>
  type TaskKeys = keyof Task | Array<keyof Task>
  can('create', 'task')

  const roles = userRoles(user)

  if (roles.administrator) {
    can(['create', 'read', 'update', 'delete', 'restore'], 'task')
  }
  if (roles.client_lead) {
    can(['update', 'delete', 'restore'], 'task')
  }
  else {
    cannot('create', 'task', ['isBillable', 'timeLimitSec', 'notificationThresholds', 'isCompleted'] as TaskKeys, {
      'project.leads.id': {
        $ne: user.id,
      },
    } as TaskQuery)

    can('update', 'task', {
      'project.leads.id': user.id,
    } as TaskQuery)

    can(['delete', 'restore'], 'task', {
      'taskList.project.leads.id': user.id,
    } as TaskQuery)

    can(['delete', 'restore'], 'task', {
      'project.leads.id': user.id,
    } as TaskQuery)
  }
}
